module.exports = __webpack_public_path__ + "img/image4.56683c1b.jpg";